module.exports = __webpack_public_path__ + "static/media/clinician-watchman-preview@2x.b7a49cd6.jpg";